/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deft_True_Buck_PlotInputs */

const en_deft_true_buck_plot = /** @type {(inputs: Deft_True_Buck_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard Changes`)
};

const de_deft_true_buck_plot = /** @type {(inputs: Deft_True_Buck_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen verwerfen`)
};

/**
* | output |
* | --- |
* | "Discard Changes" |
*
* @param {Deft_True_Buck_PlotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_true_buck_plot = /** @type {((inputs?: Deft_True_Buck_PlotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_True_Buck_PlotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_true_buck_plot(inputs)
	return de_deft_true_buck_plot(inputs)
});